import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 700,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    position: 'relative',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    '& .MuiIconButton-root': {
      padding: 4
    },
  },

  dialogStyle: {
    borderRadius: '12px !important',
    maxWidth: '75%',
    maxHeight: "100%",
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%'
    }
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  title: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "400",
    textAlign: 'center',
    margin: 16,
  },

  cardBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '30px 4em 20px 4em',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },

  statusContainer: {
    marginBottom: 10
  },

  statusBody: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "bold",
  },

  bodyText: {
    color: "#0C0B0B",
    fontFamily: "Montserrat",
    fontSize: '1.4em',
    marginBottom: 30,
    marginTop: 0,
  },

  btn: {
    width: 188,
    fontFamily: "Montserrat",
    fontSize: '1.5em',
    fontWeight: "600",
  },

  flexBox: {
    display: 'flex',
    alignItems: 'center',
  },
 
  statusTitle: {
    color: "#555D6C",
    fontFamily: "Montserrat",
    fontSize: 22,
    fontWeight: "700",
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      fontWeight: "600"
    },
  },

  paragraph: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 18,
    fontWeight: "700",
    paddingLeft: 5,
    [theme.breakpoints.down('sm')]: {
      fontSize: 15
    },  
  },
  
  description: {
    color: "#4D4D4D",
    fontFamily: "Montserrat",
    fontSize: 18,
    fontWeight: "500",
    paddingTop: 8,
    [theme.breakpoints.down('sm')]: {
      fontSize: 15
    }, 
  },

  statusSubTitle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 18,
    fontWeight: "500",
    lineHeight: "30px",
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
  },

  continueBtn: {
    fontFamily: "Montserrat",
    marginBottom: 20,
    fontSize: 16,
    fontWeight: '600',
    width: 214,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      width: 115,
      height: '40px'
    },
  },

  buttonContainer: {
    textAlign: 'center',
    margin: '0 75px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 0px'
    },
  },

  btn: {
    marginTop: '12px',
    justifyContent:'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: '24px'
    }, 
  },
 
  skipBtn: {
    width: 214,
    color: '#121D22',
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    letterSpacing: "0.53px",
    lineHeight: "19px",
    textAlign: "center",
    border: "2px solid",
    height: '40px',
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
    borderColor: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      width: 115,
      fontSize: 12,
      height: '40px'
    },
  },
 
  cardIcon: {
    width: 18,
    height: 18,
    color: "#007FFF",
    marginTop: 10
  },

  cardContent1: {
    display: 'flex'
  },
 
  info: {
    color: "#4D4D4D",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: "500",
    fontStyle: 'italic',
    paddingLeft: 5
  },
  
  infoIcon: {
    width: 24,
    height: 24,
    color: "#007FFF",
    marginTop: 10,
    [theme.breakpoints.down('sm')]: {
      width: 22,
      height: 22
    },
  },

  cardTitleBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    padding: '2px 2em',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  labelText: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "700",
  }
}));

